//Ebay Request View

//New Concept:
//When React goes to rerender an input, it must have a key. Keys need to all be the same as the previous render, container and child container!
//Otherwise inputs WILL lose focus!

import React, { useState, useEffect, useContext, useRef } from 'react';
import { useParams, useHistory } from 'react-router-dom';
import axios from "axios";
import cloneDeep from 'lodash/cloneDeep';

//CSS Styles
import flexstyles from '../../css/FlexCss';
import useClasses from '../../ui/useClasses';


import { useSelector, useDispatch } from 'react-redux';
import {
	setCurrentMenuSection,
	setCurrentMenuItem
} from '../../features/mainmenu/mainmenuSlice';

//FlexDocument
import { FlexDocument } from '../Documents/FlexDocument';

//New Error Message
import { NewErrorMessage } from '../../features/error/NewErrorMessage';
import {
	newErrorMessage,
	setErrorTimeout
} from '../../features/error/errormessageSlice';

//Contexts
import { AppContext, AppProvider } from "../Auth/contexts/AppContext";
//Error Context
//*Can be used for success as well!
//Types: ok, warning, danger, neutral
import ErrorMessage from "../common/ErrorMessage";
import { ErrorContext } from '../common/ErrorContext';

//Datetime formatting
import Moment from 'react-moment';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'; //Possibly our new adapter for mui x 7 datetime
import dayjs from 'dayjs'; //Used with new datetimepickers
//Restrict Numbers both float and integer types
import RestrictInputNumber from "../common/RestrictInputNumber";




import Checkbox from '@mui/material/Checkbox';
//import Grid from '@mui/material/Grid';
import Grid from '@mui/material/GridLegacy';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import TextareaAutosize from '@mui/material/TextareaAutosize'; 

//Icons
import SaveIcon from '@mui/icons-material/Save';
import PendingIcon from '@mui/icons-material/Pending';
import KeyboardBackspaceIcon from '@mui/icons-material/KeyboardBackspace';

//Buttons
import Button from '@mui/material/Button';

//Datetime Pickers
import TextField from '@mui/material/TextField';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker';

//DBAutoComplete
import DBAutoComplete from '../common/DBAutoComplete';

//Printing
import { useReactToPrint } from 'react-to-print';

//Record History
import RecordHistory from '../common/RecordHistory';
import { clone } from 'lodash';


/* ##########################  Configuration  ########################## */

//DB
var dbendpoint = process.env.REACT_APP_DB_API4;

//Default Axios Post Options
const defaultpostoptions = {
	withCredentials: true,
	withXSRFToken: true,
	crossDomain: true,
	mode: "no-cors",
	timeout: 11800,
};

//Axios Long Post
const longpostoptions = {
	withCredentials: true,
	withXSRFToken: true,
	crossDomain: true,
	mode: "no-cors",
	timeout: 20000,
};

//Helper Functions
//Have not used sleep just yet - is currently on auto-complete sample
function sleep(delay = 0) {
	return new Promise((resolve) => {
		setTimeout(resolve, delay);
	});
}

//Remove - Useful for completely removing object properties by key. May be used for exports.
function removeProp(obj, key) {
	for (var k in obj) {
		if (k === key) {
			delete obj[key];
			return true;
		} else if (typeof obj[k] === "object") {
			if (removeProp(obj[k], key)) return true;
		}
	}
	return false;
}

//Find Duplicate Example:
//This will short-circuit once some() finds a truthy value.
var values = [
	{ name: 'someName1' },
	{ name: 'someName2' },
	{ name: 'someName4' },
	{ name: 'someName1' }
];

var valueArr = values.map(function (item) { return item.name });
var isDuplicate = valueArr.some(function (item, idx) {
	return valueArr.indexOf(item) !== idx
});
//console.log(isDuplicate);

//Simple Find Duplicates (simple array of values).
const input = [1, 1, 2, 3, 3];
const GetDupeArray = (inputarray) => {
	var results = inputarray.reduce(function (acc, el, i, arr) {
		if (arr.indexOf(el) !== i && acc.indexOf(el) < 0) acc.push(el); return acc;
	}, []);
	return results;
}
const dupearray = GetDupeArray(input);
//console.log("Duplicates2: "+dupearray); // = 1,3 (actual array == [1, 3])

//Find and return all unique values:
const GetUniqueArray = (inputarray) => {
	return inputarray.filter((x, i, a) => a.indexOf(x) === i);
}



const EbayRequestView = (props) => {
	document.title="Ebay Request";
	const dispatch = useDispatch();
	dispatch(setCurrentMenuSection("Martin's Section"));
	dispatch(setCurrentMenuItem("/ebayrequests"));
	//URL Param for ID
	let { id } = useParams();
	console.log(id);

	let history = useHistory();

	/* App Context */
	/* Allows userperms to be used */
	const appContext = useContext(AppContext);
	const { userPerms, userRole } = appContext;

	/* CSS and Media Queries */
	const classes = useClasses(flexstyles);

	const btnSave = useRef();
	const btnPendingSave = useRef();
	const ToggleSaveBtnStatus = (haspendingsave) =>{
		//TRUE: We have pending saves.
		if (haspendingsave){
			btnSave.current.style.display = "none";
			btnPendingSave.current.style.display = "";
		} else {
		//FALSE: We no longer have pending saves.
		btnSave.current.style.display = "";
		btnPendingSave.current.style.display = "none";
		}
	}

	/* ##########################  UseState Variables  ########################## */
	const [state, setState] = useState({
		//Need to initialize a blank item
		dbreload: true, 		//Use in useEffect to check if we should reload the griditems data. Set to false when we're just updating current view items.
		itemloaded: false, //POSSIBLY MOST IMPORTANT! Using defaultValue on an input causes issues if you try to render before item is loaded.
		pendingupdate: false,
		auditview:false,
		historyavailable:false,
		recordhistory:[],
		historyindex:0,
		itemdiffs:[],
		itemdata: {
			ID: id,
			Name: "default",
			Cost: 0,
			Price: 0,
			Margin: 0,
			SomeBoolean: true,
			PositiveInteger:3
		},
		SomeBooleanDefault: true
	});

	//Some inputs will need to work via refs because we may be restricting some inputs and updating both the input itself and the JS variable
	const itemRefs = useRef({
		CostEl: "",
		PriceEl: "",
		MarginEl: "",
		PositiveIntegerEl:""
	})

	//Clone State! We'll get the view from localstate!
	let localstate = Object.assign({}, state);

	function UpdateState(stateobject) {
		setState(stateobject);
	}

	const [localstatedefaults, setLocalstateDefaults] = useState(null); 

	//Error Context
	const errors = useContext(ErrorContext);

	//Ref used for printing
	const printRef = useRef();

	const handlePrint = useReactToPrint({
		contentRef: printRef,
	});

	//Load Item
	function LoadItem() {
		const postdata = {
			ID: localstate.itemdata.ID
		};
		axios.post(dbendpoint + "/ebayrequests/getitem", postdata, defaultpostoptions).then(res => {
			//Rule #1: API should be setup to send 200 response with status. Merge paginated requests.
			if (res.status === 200) {
				//If ValidateUser() fails to verify user, it sends back 'login' error. 
				if (res.data.Status === "login") {
					//Not logged in. Reload page causes redirect to /login
					window.location.reload(false);
				}
				//All new API calls should return a status.
				if (res.data.Status === "Success") {
					localstate.itemdata = res.data.item;

					//Datetime Formatting
					//localstate.itemdata.ItemCreationDate = dayjs(localstate.itemdata.ItemCreationDate);
					localstate.itemdata.updated_at = dayjs(localstate.itemdata.updated_at);
					localstate.itemdata.created_at = dayjs(localstate.itemdata.created_at);

				
					for (var i=0;i<localstate.itemdata.results.length; i++){
						localstate.itemdata.results[i].ItemCreationDate = dayjs(localstate.itemdata.results[i].ItemCreationDate); 
						console.log("###################################################");
						console.log(localstate.itemdata.results[i].ItemCreationDate);
					}
				
					//Evaluate Editable:
					localstate.editable = false;
					//If user can create and the item is PendingItem, allow a single edit.
					if (localstate.itemdata.PendingItem === 1 && userPerms.createDemoData === 1){
						localstate.editable = true;
					} else if (userPerms.updateDemoData === 1){
						localstate.editable = true;
					}

					localstate.dbreload = false;
					//Set Defaults on first load:
					if (!localstate.itemloaded){
						localstate.itemdatadefaults = localstate.itemdata;
						localstate.itemloaded = true; //Now allow render
					}
					//Show a warning to the user when they're viewing a deleted item
					if (localstate.itemdata.SoftDelete===1){
						dispatch(newErrorMessage({ errmsg: "This is a deleted item.", errshow: true, errtimeout: 30000, errtype: "danger" }));
						dispatch(setErrorTimeout(30000));
					}
					//Clone for defaults
					setLocalstateDefaults(Object.assign({}, localstate));
					UpdateState(localstate);
				}
				if (res.data.Status === "Failure") {
					//Failure error
					localstate.dbreload = false;
					UpdateState(localstate);
					dispatch(newErrorMessage({ errmsg: res.data.message, errshow: true, errtimeout: 10, errtype: "neutral" }));
					dispatch(setErrorTimeout(10));
				}
			} else {
				//Non-200 message from server.
				dispatch(newErrorMessage({ errmsg: "Bad response from server.", errshow: true, errtimeout: 15, errtype: "warning" }));
				dispatch(setErrorTimeout(15));
			}
		});
	}



	useEffect(() => {
		//To Do: On load of item, set title to the serial number.
		document.title = "Ebay Request";
		if (state.dbreload) {
			//Avoid duplicate loads.
			localstate.dbreload = false;
			//Diagnostic:
			console.log("Localstate ID: " + localstate.itemdata.ID);
			LoadItem();
		}
	}, [state]);


	function debounce(func, wait, immediate) {
		var timeout;
		return function () {
			var context = this, args = arguments;
			var later = function () {
				timeout = null;
				if (!immediate) func.apply(context, args);
			};
			var callNow = immediate && !timeout;
			clearTimeout(timeout);
			timeout = setTimeout(later, wait);
			if (callNow) func.apply(context, args);
		};
	};

	const SaveChanges = () => {
		//Hide current errors:
		dispatch(setErrorTimeout(0));

		if (localstate.itemdata.Name.length === 0){
			dispatch(newErrorMessage({ errmsg: "warning", errshow: true, errtimeout: 15, errtype: "warning" }));
			dispatch(setErrorTimeout(15));
			return;
		}

		let postdata = {
			item: localstate.itemdata
		}
		if (deleteitem) {
			postdata.item.DeleteItem = true;
		}
		axios.post(dbendpoint + "/ebayrequests/update", postdata, defaultpostoptions).then(res => {
			//API should be setup to send 200 response with status. Merge paginated requests.
			if (res.status === 200) {
				//If ValidateUser() fails to verify user, it sends back 'login' error. 
				if (res.data.Status === "login") {
					//Not logged in. Reload page causes redirect to /login
					window.location.reload(false);
				}
				//All new API calls should return a status.
				if (res.data.Status === "Success") {
					btnSave.current.style.display="";
					btnPendingSave.current.style.display="none";
					//Attempt to replace: btnSave.current.disabled = true;
					localstate.pendingsaves = false;
					localstate.dbreload = true;
					UpdateState(localstate);
					dispatch(newErrorMessage({ errmsg: "Saved successfully.", errshow: true, errtimeout: 15, errtype: "ok" }));
					dispatch(setErrorTimeout(10));
				}
				if (res.data.Status === "Deleted") {
					history.push("/ebayrequests");
					dispatch(setErrorTimeout(0));
				}
				if (res.data.Status === "Failure") {
					//Failure error
					dispatch(newErrorMessage({ errmsg: res.data.message, errshow: true, errtimeout: 15, errtype: "warning" }));
					dispatch(setErrorTimeout(15));
				}
			} else {
				//Non-200 message from server.
				dispatch(newErrorMessage({ errmsg: "Bad response from server.", errshow: true, errtimeout: 15, errtype: "warning" }));
				dispatch(setErrorTimeout(15));
			}
		});
	}



	//Changes to item
	const onChangeValue = (event, itemkey) => {
		var oldvalue = localstate.itemdata[itemkey];
		var newvalue = event.target.value;
		if (event.key !== "Tab" &&
			event.key !== "ArrowDown" &&
			event.key !== "ArrowUp" &&
			event.key !== "ShiftLeft" &&
			event.key !== "ShiftRight"
		) {

			if (itemkey === "EnableEmails") {
				if (event.target.checked) {
					localstate.itemdata.EnableEmails = 1;
				} else {
					localstate.itemdata.EnableEmails = 0;
				}
			}

			if (itemkey === "DenyNonVariance") {
				if (event.target.checked) {
					localstate.itemdata.DenyNonVariance = 1;
				} else {
					localstate.itemdata.DenyNonVariance = 0;
				}
			}

			//Float
			if (itemkey === "Cost" || 
				itemkey === "Price" || 
				itemkey === "Margin" || 
				itemkey === "TargetPrice" || 
				itemkey === "TargetVariance" ||
				itemkey === "MinPrice" ||
				itemkey === "MaxPrice"
				) {
				if (!oldvalue){
					oldvalue="0";
				}
				//A new value from RestrictInputNumber means it will override the input. We'll attempt to place the cursor back where it was. Otherwise, take in new value and do not adjust the input.
				newvalue = RestrictInputNumber(newvalue, oldvalue, event, "float"); //All arguments required. New universal function for all pages. However handle result below.
				if (newvalue) {
					itemRefs.current[itemkey+"El"].value = newvalue;
					localstate.itemdata[itemkey] = newvalue;
					//Attempt to refocus and place cursor at the end of the input - This will require we switch the input to text, then back to number:
					const inputElement = itemRefs.current[itemkey+"El"];
					inputElement.type = 'text';
					inputElement.focus();
					inputElement.setSelectionRange(inputElement.value.length, inputElement.value.length);
					inputElement.type = 'number';
				} else {
					console.log("No newvalue returned, set value in localstate, but leave input untouched.");
					console.log(parseFloat(event.target.value).toFixed(2));
					localstate.itemdata[itemkey] = parseFloat(event.target.value).toFixed(2);
				}
			}

			//Positive Integer:
			if (itemkey === "PositiveInteger" || itemkey === "Limit" || itemkey === "UpdateFrequency") {
				if (!oldvalue){
					oldvalue="0";
				}
				//A new value from RestrictInputNumber means it will override the input. We'll attempt to place the cursor back where it was. Otherwise, take in new value and do not adjust the input.
				newvalue = RestrictInputNumber(newvalue, oldvalue, event, "positiveinteger"); //All arguments required. New universal function for all pages. However handle result below.
				if (newvalue) {
					itemRefs.current[itemkey+"El"].value = newvalue;
					localstate.itemdata[itemkey] = newvalue;
					//Attempt to refocus and place cursor at the end of the input - This will require we switch the input to text, then back to number:
					const inputElement = itemRefs.current[itemkey+"El"];
					inputElement.type = 'text';
					inputElement.focus();
					inputElement.setSelectionRange(inputElement.value.length, inputElement.value.length);
					inputElement.type = 'number';
				} else {
					console.log("No newvalue returned, set value in localstate, but leave input untouched.");
					console.log(parseInt(event.target.value));
					localstate.itemdata[itemkey] = parseInt(event.target.value);
				}
			}

			//All others
			if (itemkey === "Name" || itemkey === "LastName" || itemkey==="Date" || 
				itemkey==="Notes" || itemkey==="SearchTerms" || itemkey==="NotTerms" || itemkey==="Sort" || itemkey === "Category" || itemkey==="SendToAddress" || itemkey === "SendToName") {
				localstate.itemdata[itemkey] = newvalue;
			}
			localstate.pendingsaves = true;
			//Old
			// btnSave.current.style.color = "white";
			// btnSave.current.style.backgroundColor = "#01579B";
			btnSave.current.style.display="none";
			btnPendingSave.current.style.display="";
			//This is casuing rerender.... Sets off variance colors... every rerender.
			//UpdateState(localstate);
		}

	}



	//New method to target what is sent from a datetime picker:
	const onChangeDatetimeValue = (newvalue, itemkey) => {
		localstate.itemdata[itemkey] = newvalue;
		localstate.pendingsaves = true;
		ToggleSaveBtnStatus(true);
		UpdateState(localstate);
	}


	//Record History
	const ViewRecordHistory = () => {
		//Initiate record history and load last history item for immediate viewing!
		var historylength = localstate.recordhistory.length;
		//Use length-1 for last index
		localstate.historyindex = historylength - 1;
		//localstate.itemdata = Object.assign({}, localstate.recordhistory[historylength-1]);
		localstate.itemdata = cloneDeep(localstate.recordhistory[historylength - 1]);
		//Diffs
		if ((historylength - 1) !== 0) {
			GetDiffs(localstate.itemdata, localstate.recordhistory[localstate.recordhistory.length - 2]);
		} else {
			//Reset diffs:
			for (let key in localstate.itemdata) {
				localstate.itemdiffs[key] = {};
				localstate.itemdiffs[key].dirty = false;
			}
		}
		//Pre-Formatted currency
		localstate.itemdata.Cost = parseFloat(localstate.recordhistory[localstate.recordhistory.length - 1].Cost).toFixed(2);
		localstate.auditview = true;
		UpdateState(localstate);
	}

	const ViewRecord = (newindex) => {
		//Provision to go back to live view:
		if (newindex === localstate.recordhistory.length) {
			//All out of history records, go back to live
			localstate.dbreload = true;
			localstate.auditview = false;
			localstate.itemloaded = false; //Helps rerender! No kidding. After reload, it'll force rerender contents.
			UpdateState(localstate);
		} else {
			localstate.historyindex = newindex;
			localstate.itemdata = localstate.recordhistory[newindex];
			//Diffs
			localstate.itemdiffs = {};
			if (newindex !== 0) {
				GetDiffs(localstate.itemdata, localstate.recordhistory[newindex - 1]);
			} else {
				//Reset diffs:
				for (let key in localstate.itemdata) {
					localstate.itemdiffs[key] = {};
					localstate.itemdiffs[key].dirty = false;
				}
			}
			//Pre-Formatted currency
			localstate.itemdata.Cost = parseFloat(localstate.itemdata.Cost).toFixed(2);
			UpdateState(localstate);
		}
	}

	const GetDiffs = (currentrecord, previousrecord) => {
		for (let key in currentrecord) {
			localstate.itemdiffs[key] = {};
			if (currentrecord[key] !== previousrecord[key]) {
				localstate.itemdiffs[key].dirty = true;
				//We can also setup some kind of greaterthan / lessthan setup one day. 
				//localstate.itemdiffs[key].greaterthanvalue = something;
			} else {
				localstate.itemdiffs[key].dirty = false;
			}
		}
	}

	const RestoreRecord = () => {
		//Notice: YOU WILL NEED TO MAKE ADJUSTMENTS TO YOUR API TO INCLUDE NESTED RELATIONSHIPS
		//Assuming everything is stored in localstate.itemdata (our traversal of RecordHistory helps this)
		//Let's try to send it right back to our update:
		//Send a flag with our item so our update() api endpoint can make specific adjustments.
		localstate.itemloaded = false; //Forces rerender.
		localstate.itemdata["RestoreRecord"] = 1;
		localstate.auditview = false;

		SaveChanges();
	}

	const GoToRequests = () => {
		history.push('/ebayrequests');
	}


	//Let's try to set a default value for our AutoComplete
	const [testDBAC, setDBAC] = useState('Some UseState Default');

	const onDBAutoCompleteChange = (newvalue, searchkey) =>{
		console.log(newvalue);
		//We can parse results by using keys - this makes the function reusable so we can insert many DBAutoComplete Components
		if (searchkey==="products"){
			//console.log("Set new value: "+newvalue.Vendor);
			//setDBAC(newvalue.Vendor);


			localstate.itemdata.ProductID = newvalue.ProductID;
			ToggleSaveBtnStatus(true);
			UpdateState(localstate);
			
		} 
	}


	//UseState variable controls warning message as well as checked status of Checkbox
	const [deleteitem, setDeleteItem] = useState(false);
	const markForDelete = () =>{
		if (!deleteitem) {
			dispatch(newErrorMessage({ errmsg: "Item has been marked for deletion. Click 'Save Changes' to complete deletion.", errshow: true, errtimeout: 30000, errtype: "warning" }));
			dispatch(setErrorTimeout(30000));
			ToggleSaveBtnStatus(true);
		} else {
			dispatch(newErrorMessage({ errmsg: "Deletion cancelled.", errshow: true, errtimeout: 10, errtype: "ok" }));
			dispatch(setErrorTimeout(10));
			ToggleSaveBtnStatus(false); //Remove access to regular save button if neccessary.
		}
		setDeleteItem(!deleteitem);
	}




	
	/* ##########################  Post Test  ########################## */
	//Useful for making test API calls.
	// Simply remove customendpoint if you want to call the basic testpost method at the top of BasicTableController.
	const TestPost = (customendpoint) =>{
		if(!customendpoint){customendpoint="/testpost"}
		//Sample postdata.
		const postdata = {
			item:localstate.itemdata
		};
		axios.post(dbendpoint+customendpoint, postdata, defaultpostoptions).then(res => {
			//API should be setup to send 200 response with status. Merge paginated requests.
			if (res.status===200){
				//If ValidateUser() fails to verify user, it sends back 'login' error. 
				if (res.data.Status==="login"){
					//Not logged in. Reload page causes redirect to /login
					window.location.reload(false);
				}
				//All new API calls should return a status.
				if (res.data.Status==="Success"){
					console.log(res);
				}
				if (res.data.Status==="Failure"){
					//Failure error
					dispatch(newErrorMessage({ errmsg: res.data.message, errshow: true, errtimeout: 10, errtype: "neutral" }));
					dispatch(setErrorTimeout(10));
				}
			} else {
				//Non-200 message from server.
				dispatch(newErrorMessage({ errmsg: "Bad response from server.", errshow: true, errtimeout: 15, errtype: "warning" }));
				dispatch(setErrorTimeout(15));
			}
		});
	}

	const ClearResults = () =>{
		//Sample postdata.
		const postdata = {
			ID:localstate.itemdata.ID
		};
		axios.post(dbendpoint+"/ebayrequests/clearresults", postdata, defaultpostoptions).then(res => {
			//API should be setup to send 200 response with status. Merge paginated requests.
			if (res.status===200){
				//If ValidateUser() fails to verify user, it sends back 'login' error. 
				if (res.data.Status==="login"){
					//Not logged in. Reload page causes redirect to /login
					window.location.reload(false);
				}
				//All new API calls should return a status.
				if (res.data.Status==="Success"){
					dispatch(newErrorMessage({ errmsg: "Results cleared successfully.", errshow: true, errtimeout: 10, errtype: "ok" }));
					dispatch(setErrorTimeout(10));
					localstate.dbreload = true;
					UpdateState(localstate);
				}
				if (res.data.Status==="Failure"){
					//Failure error
					dispatch(newErrorMessage({ errmsg: res.data.message, errshow: true, errtimeout: 10, errtype: "neutral" }));
					dispatch(setErrorTimeout(10));
				}
			} else {
				//Non-200 message from server.
				dispatch(newErrorMessage({ errmsg: "Bad response from server.", errshow: true, errtimeout: 15, errtype: "warning" }));
				dispatch(setErrorTimeout(15));
			}
		});
	}

	const SendRequest = (customendpoint) =>{
		if(!customendpoint){customendpoint="/ebayrequests/get"}
		//Sample postdata.
		console.log(localstate.itemdata);
		const postdata = {
			//Allow controller to construct query, we'll need to do it from system jobs anyway.
			//Just send ID.
			item: localstate.itemdata
		};
		axios.post(dbendpoint+customendpoint, postdata, defaultpostoptions).then(res => {
			//API should be setup to send 200 response with status. Merge paginated requests.
			if (res.status===200){
				//If ValidateUser() fails to verify user, it sends back 'login' error. 
				if (res.data.Status==="login"){
					//Not logged in. Reload page causes redirect to /login
					window.location.reload(false);
				}
				//All new API calls should return a status.
				if (res.data.Status==="Success"){
					dispatch(newErrorMessage({ errmsg: res.data.message, errshow: true, errtimeout: 10, errtype: "ok" }));
					dispatch(setErrorTimeout(240));
					localstate.dbreload = true;
					UpdateState(localstate);
				}
				if (res.data.Status==="Failure"){
					//Failure error
					dispatch(newErrorMessage({ errmsg: res.data.message, errshow: true, errtimeout: 10, errtype: "neutral" }));
					dispatch(setErrorTimeout(120));
				}
			} else {
				//Non-200 message from server.
				dispatch(newErrorMessage({ errmsg: "Bad response from server.", errshow: true, errtimeout: 15, errtype: "warning" }));
				dispatch(setErrorTimeout(120));
			}
		});
	}

	function getColorFromVariance(price, target, variance) {
		//price = 11;
		//Price: 9
		//Target: 10
		//Variance: 1 (also variance upper)

		var varianceupper = cloneDeep(variance);
		console.log("Variance upper: "+varianceupper);
		var variancelower = -cloneDeep(variance);
		console.log("Variance lower: "+variancelower);

		var delta = price-target; 
		//9-10 = -1;

		var difference = delta-variancelower;
		// -1 -(-1) = 0
		console.log("Variance difference: "+difference);

		var variancerange = 2*cloneDeep(variance);

		var variancepercent = (difference/variancerange)*100;
		console.log("Variance Percent: "+variancepercent);

		if (variancepercent>100){
			variancepercent=100;
		}
		if (variancepercent<0){
			variancepercent=0;
		}

		//Lowervalue: (start of blue)
		var lowerbound = target-variance;
		//10-1 = 9
		var upperbound = target+variance;
		//10+1 = 11

		//Green to red
		const hue = (120 * (100 - variancepercent)) / 100; // 120 (green) → 0 (red)
		return `hsl(${hue}, 100%, 50%)`;

		//Blue to red
		// const hue = 240 - (variancepercent / 100) * 240; // 240 (blue) → 0 (red/yellow zone)
		// return `hsl(${hue}, 100%, 50%)`;
	  }


	/* 
	                                                                                         
         _/_/_/        _/_/_/_/       _/      _/       _/_/_/        _/_/_/_/       _/_/_/    
        _/    _/      _/             _/_/    _/       _/    _/      _/             _/    _/   
       _/_/_/        _/_/_/         _/  _/  _/       _/    _/      _/_/_/         _/_/_/      
      _/    _/      _/             _/    _/_/       _/    _/      _/             _/    _/     
     _/    _/      _/_/_/_/       _/      _/       _/_/_/        _/_/_/_/       _/    _/      
                                                                                         
                                                                                         
 	*/
	/* ##########################  Render Function  ########################## */
	return (
		<LocalizationProvider dateAdapter={AdapterDayjs}>
			{(localstate.itemloaded) &&
			<div style={{ padding: "8px", textAlign: "center", margin: "auto", marginBottom: "100px", overflow:"auto", maxWidth:"90%" }} ref={printRef}>

				{/* Standard Page Header with right floated error message space */}
				{/* Min-Width here should coincide with min-width of Grid */}
				<div style={{ position: "relative", paddingTop: "5px", minWidth: "450px" }}>
					<div style={{ textAlign: "center" }}>
						<h2>Ebay Request</h2>
					</div>
					{(process.env.NODE_ENV === "development") &&
						<div>Warning: Dev mode likely cannot be use for requests. Issue with localhost likely.</div>
					}
					{(userPerms.updateDemoData===1) &&
							<Box sx={{ '& button': { m: 1 }, displayPrint:'none' }}>
								<Button
									className={classes.bluebtn}
									color="primary" variant="contained"
									onClick={() => GoToRequests()}>
									<KeyboardBackspaceIcon sx={{ color: "lightgray" }}></KeyboardBackspaceIcon>&nbsp;Back to All Requests
								</Button>
								<Button
									className={(userPerms.updateDemoData === 1 && !localstate.auditview) ? classes.bluebtn : classes.hidden }
									color="primary" variant="contained"
									onClick={() => SaveChanges()}
									ref={el => btnSave.current = el}>
									<SaveIcon sx={{color:"lightgray"}}></SaveIcon>&nbsp;Save Changes
								</Button>
								<Button
									className={(userPerms.updateDemoData === 1 || userPerms.createDemoData === 1)  && !localstate.auditview ? classes.bluebtn : classes.hidden }
									color="primary" variant="contained"
									style={{display:"none"}}
									onClick={() => SaveChanges()}
									ref={el => btnPendingSave.current = el}>
									<PendingIcon sx={{color:"orange"}}></PendingIcon>&nbsp;Save Changes
								</Button>
								{/* <Button
									className={(!localstate.auditview ? classes.bluebtn: classes.hidden)}
									color="primary" variant="contained"
									onClick={() => handlePrint()}>
									Print
								</Button> */}
								<Button
									className={(!localstate.auditview ? classes.bluebtn: classes.hidden)}
									color="primary" variant="contained"
									onClick={() => SendRequest()}>
									Send Request
								</Button>
								<Button
									className={(!localstate.auditview ? classes.bluebtn: classes.hidden)}
									color="primary" variant="contained"
									onClick={() => ClearResults()}>
									Clear Results
								</Button>
								{(localstate.auditview && userPerms.updateDemoData) &&
									<Button
										className={classes.orangebtn}
										color="primary" variant="contained"
										onClick={() => RestoreRecord()}>
										Restore This Record
									</Button>
								}
								{(localstate.itemdata.SoftDelete===1 && userRole==='admin') &&
									<Button
										className={classes.orangebtn}
										color="primary" variant="contained"
										onClick={() => RestoreRecord()}>
										Restore This Record
									</Button>
								}
							</Box>
					}
					<Box sx={{displayPrint:'none', height:"26px", display:"block"}}>
						<NewErrorMessage />
					</Box>
				</div>

				{/* LIVE VIEW */}
				{(!localstate.auditview) &&
				<Typography variant="h6">
				<Grid container spacing={0} sx={{minWidth:"450px"}}>
					<div className={classes.itemtableheader} style={{display:"flex"}}>
						<div style={{flexGrow:1}}>Request Details</div>
					</div>
					
					<Grid item sm={12} md={6}>
						<div className={classes.flextabledebug}>
							<table className={classes.itemtable}>
								<tbody>
									<tr>
										<td style={{ width: "160px",}}>
											Request Name:
										</td>
										<td>
											<input className={classes.flexiteminput}
												maxLength="100" //Needs max length
												type="text"
												defaultValue={localstatedefaults.itemdata.Name}
												onChange={(event) => onChangeValue(event, "Name")}
											/>
										</td>
									</tr>
									<tr>
										<td>
											Target Price:
										</td>
										<td>
											{(userPerms.updateDemoData===1) &&
												<input className={classes.flexiteminput}
												ref={el => itemRefs.current.TargetPriceEl = el}
												type="number"
												step="0.01"
												defaultValue={localstate.itemdata.TargetPrice}
												onKeyUp={(event) => onChangeValue(event, "TargetPrice")}
											/>
											}
											{(userPerms.updateDemoData===0) &&
												<div className={classes.flexitemstaticinput}>
													{localstate.itemdata.TargetPrice}
												</div>
											}												
										</td>
									</tr>
									<tr>
										<td>
											Target Variance:
										</td>
										<td>
											{(userPerms.updateDemoData===1) &&
												<input className={classes.flexiteminput}
												ref={el => itemRefs.current.TargetVarianceEl = el}
												type="number"
												step="0.01"
												defaultValue={localstate.itemdata.TargetVariance}
												onKeyUp={(event) => onChangeValue(event, "TargetVariance")}
											/>
											}
											{(userPerms.updateDemoData===0) &&
												<div className={classes.flexitemstaticinput}>
													{localstate.itemdata.TargetVariance}
												</div>
											}												
										</td>
									</tr>
									<tr>
										<td>
											Min Price:
										</td>
										<td>
											{(userPerms.updateDemoData===1) &&
												<input className={classes.flexiteminput}
												ref={el => itemRefs.current.MinPriceEl = el}
												type="number"
												step="0.01"
												defaultValue={localstate.itemdata.MinPrice}
												onKeyUp={(event) => onChangeValue(event, "MinPrice")}
											/>
											}
											{(userPerms.updateDemoData===0) &&
												<div className={classes.flexitemstaticinput}>
													{localstate.itemdata.MinPrice}
												</div>
											}												
										</td>
									</tr>
									<tr>
										<td>
											Max Price:
										</td>
										<td>
											{(userPerms.updateDemoData===1) &&
												<input className={classes.flexiteminput}
												ref={el => itemRefs.current.MaxPriceEl = el}
												type="number"
												step="0.01"
												defaultValue={localstate.itemdata.MaxPrice}
												onKeyUp={(event) => onChangeValue(event, "MaxPrice")}
											/>
											}
											{(userPerms.updateDemoData===0) &&
												<div className={classes.flexitemstaticinput}>
													{localstate.itemdata.MaxPrice}
												</div>
											}												
										</td>
									</tr>
									<tr>
										<td>
											Limit:
										</td>
										<td>
											{(userPerms.updateDemoData===1) &&
												<input className={classes.flexiteminput}
												ref={el => itemRefs.current.LimitEl = el}
												type="number"
												step="1"
												defaultValue={localstate.itemdata.Limit}
												onKeyUp={(event) => onChangeValue(event, "Limit")}
											/>
											}
											{(userPerms.updateDemoData===0) &&
												<div className={classes.flexitemstaticinput}>
													{localstate.itemdata.Limit}
												</div>
											}												
										</td>
									</tr>
										{/* <tr>
											<td>
												Name (dropdown):
											</td>
											<td>
												<FormControl variant="standard" className={classes.flexitembasicselect} sx={{ m: 0, width: "100%", border: "0px" }}>
													<Select
														variant="standard"
														value={localstate.itemdata.Name}
														displayEmpty
														onChange={(event) => onChangeValue(event, "Name")}
														//Setting value means React will try to consider this a controlled component.
														//If you don't set a default value in state (before DB load), it will try to evaluate an undefined value and switch back to uncontrolled.
														//This will present an error when the component tries to go back to controlled.
														renderValue={
															(selected) => {
																return <Typography variant="h6">{localstate.itemdata.Name}</Typography>;
															}
														}
													>
														<MenuItem value={"James"}>James</MenuItem>
														<MenuItem value={"Martin"}>Martin</MenuItem>
														<MenuItem value={"Adam"}>Adam</MenuItem>
													</Select>
												</FormControl>
											</td>
										</tr> */}
									
								
											
											


								</tbody>
							</table>
						</div>
					</Grid>
					<Grid item sm={12} md={6}>
						<div className={classes.flextabledebug}>
							<table className={classes.itemtable}>
								<tbody>
								<tr>
										<td>
											Created By:
										</td>
										<td>
											<div className={classes.flexitemstaticinput}>
												{(localstate.itemdata.hasOwnProperty('creationuser') ? (localstate.itemdata.creationuser !== null ? localstate.itemdata.creationuser.firstname + " " + localstate.itemdata.creationuser.lastname : "") : "")}
											</div>
										</td>
									</tr>

									<tr>
										<td>
											Updated At:
										</td>
										<td>
											<div className={classes.flexitemstaticinput}>
												{dayjs(localstate.itemdata.updated_at).format("MMMM D, YYYY [at] h:mma")}
											</div>
										</td>
										</tr>

										<tr>
											<td>
												Updated By:
											</td>
											<td>
												<div className={classes.flexitemstaticinput}>
												{(localstate.itemdata.hasOwnProperty('updateuser') ? (localstate.itemdata.updateuser!==null ? localstate.itemdata.updateuser.firstname+" "+localstate.itemdata.updateuser.lastname : "") : "")}
												</div>
											</td>
												</tr>

												<tr>
													<td style={{ width: "160px" }}>
														Category:
													</td>
													<td>
														<input className={classes.flexiteminput}
															maxLength="100" //Needs max length
															type="text"
															defaultValue={localstatedefaults.itemdata.Category}
															onChange={(event) => onChangeValue(event, "Category")}
														/>
													</td>
												</tr>


												<tr>
													<td style={{ width: "160px", paddingTop: "8px" }}>
														Enable Emails:
													</td>
													<td style={{ verticalAlign: "bottom", paddingBottom: "4px" }}>
														{(userPerms.updateDemoData === 1) &&
															<Checkbox
																className={classes.gridcheckbox}
																defaultChecked={(localstatedefaults.itemdata.EnableEmails === 1 ? true : false)}
																onClick={(event) => onChangeValue(event, "EnableEmails")} />
														}
														{(userPerms.updateDemoData === 0) &&
															<Checkbox
																disabled
																defaultChecked={(localstatedefaults.itemdata.EnableEmails === 1 ? true : false)}
																onClick={(event) => onChangeValue(event, "EnableEmails")} />
														}
													</td>
												</tr>

												<tr>
													<td style={{ width: "160px" }}>
														Send To Name:
													</td>
													<td>
														<input className={classes.flexiteminput}
															maxLength="100" //Needs max length
															type="text"
															defaultValue={localstatedefaults.itemdata.SendToName}
															onChange={(event) => onChangeValue(event, "SendToName")}
														/>
													</td>
												</tr>

												<tr>
													<td style={{ width: "160px" }}>
														Send To Addr:
													</td>
													<td>
														<input className={classes.flexiteminput}
															maxLength="100" //Needs max length
															type="text"
															defaultValue={localstatedefaults.itemdata.SendToAddress}
															onChange={(event) => onChangeValue(event, "SendToAddress")}
														/>
													</td>
												</tr>

												<tr>
													<td style={{ width: "160px", paddingTop: "8px" }}>
														Deny Non-Variance:
													</td>
													<td style={{ verticalAlign: "bottom", paddingBottom: "4px" }}>
														{(userPerms.updateDemoData === 1) &&
															<Checkbox
																className={classes.gridcheckbox}
																defaultChecked={(localstatedefaults.itemdata.DenyNonVariance === 1 ? true : false)}
																onClick={(event) => onChangeValue(event, "DenyNonVariance")} />
														}
														{(userPerms.updateDemoData === 0) &&
															<Checkbox
																disabled
																defaultChecked={(localstatedefaults.itemdata.DenyNonVariance === 1 ? true : false)}
																onClick={(event) => onChangeValue(event, "DenyNonVariance")} />
														}
													</td>
												</tr>
												<tr>
											<td>
												Sort by:
											</td>
											<td>
												<FormControl variant="standard" className={classes.flexitembasicselect} sx={{ m: 0, width: "100%", border: "0px" }}>
													<Select
														variant="standard"
														defaultValue={localstatedefaults.itemdata.Sort}
														displayEmpty
														onChange={(event) => onChangeValue(event, "Sort")}
														//Setting value means React will try to consider this a controlled component.
														//If you don't set a default value in state (before DB load), it will try to evaluate an undefined value and switch back to uncontrolled.
														//This will present an error when the component tries to go back to controlled.
														sx={{ typography: 'h6' }}
													>
														<MenuItem value={"ItemCreationDate"}>Newly Listed</MenuItem>
														<MenuItem value={"AverageUnitPriceAsc"}>Average Unit Price Asc</MenuItem>
														<MenuItem value={"AverageUnitPriceDesc"}>Average Unit Price Desc</MenuItem>
														<MenuItem value={"LowestPrice"}>Lowest Price</MenuItem>
														<MenuItem value={"HighestPrice"}>Highest Price</MenuItem>
													</Select>
												</FormControl>
											</td>
										</tr>

										<tr>
										<td>
											Update Frequency (min):
										</td>
										<td>
											{(userPerms.updateDemoData===1) &&
												<input className={classes.flexiteminput}
												ref={el => itemRefs.current.UpdateFrequencyEl = el}
												type="number"
												step="1"
												defaultValue={localstate.itemdata.UpdateFrequency}
												onKeyUp={(event) => onChangeValue(event, "UpdateFrequency")}
											/>
											}
											{(userPerms.updateDemoData===0) &&
												<div className={classes.flexitemstaticinput}>
													{localstate.itemdata.UpdateFrequency}
												</div>
											}												
										</td>
									</tr>
									
									<tr></tr>

								
									{(userPerms.deleteDemoData===1 && localstate.itemdata.SoftDelete===0) &&
									<>
										<tr><td></td><td><hr /></td></tr>
										<tr>
											<td style={{ width: "160px", paddingTop: "8px" }}>
												Delete Item:
											</td>
											<td style={{ verticalAlign: "bottom", paddingBottom: "4px" }}>
													<Checkbox
													checked={deleteitem}
													className={classes.gridcheckbox}
													onClick={() => markForDelete()} />						
											</td>
										</tr>
									</>
									}

								</tbody>
							</table>
						</div>
					</Grid>


					<Grid item sm={12} md={12}>
						<div className={classes.flextabledebug}>
							<table className={classes.itemtable}>
								<tbody>
								<tr>
									<td style={{ width: "160px", paddingTop: "8px" }}>
										Search Terms:
									</td>
									<td>
										<TextareaAutosize
											disabled={userPerms.updateDemoData ? false : true}
											style={{ minHeight: "50px", backgroundColor: "#dbffdf" }}
											className={classes.flexiteminput}
											defaultValue={localstate.itemdata.SearchTerms}
											onKeyUp={(event) => onChangeValue(event, "SearchTerms")}
										/>
									</td>
								</tr>
								</tbody>
							</table>
						</div>
					</Grid>

					<Grid item sm={12} md={12}>
						<div className={classes.flextabledebug}>
							<table className={classes.itemtable}>
								<tbody>
								<tr>
									<td style={{ width: "160px", paddingTop: "8px" }}>
										Deny Terms:
									</td>
									<td>
										<TextareaAutosize
											disabled={userPerms.updateDemoData ? false : true}
											style={{ minHeight: "50px", backgroundColor: "#ffd0d0" }}
											className={classes.flexiteminput}
											defaultValue={localstate.itemdata.NotTerms}
											onKeyUp={(event) => onChangeValue(event, "NotTerms")}
										/>
									</td>
								</tr>
								</tbody>
							</table>
						</div>
					</Grid>



					<div className={classes.itemtableheader} style={{display:"flex"}}>
						<div style={{flexGrow:1}}>Request Results</div>
					</div>
					
					<Grid item sm={12} md={12}>
					
						<div className={classes.flextabledebug}>
							<table className={classes.simpletable} style={{tableLayout:"inherit", fontSize:"18px"}}>
								<tbody>
									<tr>
										<td style={{borderBottom:"2px solid #CCC"}}>

										</td>
										<td style={{borderBottom:"2px solid #CCC"}}>
											Date
										</td>
										<td style={{textAlign:"left", borderBottom:"2px solid #CCC"}}>
											Details
										</td>
										<td style={{textAlign:"right", borderBottom:"2px solid #CCC"}}>
											Price
										</td>
										<td style={{textAlign:"right", borderBottom:"2px solid #CCC"}}>
											Avg
										</td>
										<td style={{borderBottom:"2px solid #CCC", textAlign:"right", paddingRight:"8px"}}>
											Seller
										</td>
									</tr>
									{(localstate.itemdata.results.length>0) &&
										<>
											{localstate.itemdata.results.map((result, resultindex)=>{
												//some Logix?
												return(
													<tr key={resultindex}>
														<td style={{borderBottom:"1px solid #AAA", textAlign:"center", padding:"3px 3px"}}>
															<div style={{width:"150px", height:"150px"}}>
															<a href={result.Url} target="_blank"><img src={result.ThumbnailImage} style={{maxWidth:"100%", maxHeight:"100%"}} /></a>
															</div>
															
														</td>
														<td style={{borderBottom:"1px solid #AAA",verticalAlign:"top"}}>
															{dayjs(result.ItemCreationDate).format("MMMM D, YYYY [at] h:mma")}
														</td>
														<td style={{textAlign:"left", borderBottom:"1px solid #AAA", verticalAlign:"top"}}>
															<a href={result.Url} target="_blank"> {result.Title}</a><br></br>
															{result.ItemID}
														</td>
														<td style={{textAlign:"right", borderBottom:"1px solid #AAA", verticalAlign:"top"}}>
															{result.Price}
														</td>
														<td style={{textAlign:"right",
															borderBottom:"1px solid #AAA",
															verticalAlign:"top",
															backgroundColor: getColorFromVariance(result.AverageUnitPrice, localstate.itemdata.TargetPrice, localstate.itemdata.TargetVariance)}}>
															{result.AverageUnitPrice}
														</td>
														<td style={{borderBottom:"1px solid #AAA", verticalAlign:"top", textAlign:"right", paddingRight:"8px"}}>
															{result.Username} &nbsp; {result.SellerFeedback}%
														</td>
													</tr>
													
												)
											})}
										</>
									}
								</tbody>
							</table>
						</div>
				
					</Grid>


				</Grid>

		

				
				
			</Typography>
				}
			</div>
		}
		</LocalizationProvider>
	)
}

export default EbayRequestView;
